import { Component, HostListener, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ChaseError } from '@app/interfaces/payment-tech.interface';
// import { IconDefinition, faCreditCard } from '@fortawesome/free-solid-svg-icons';
// import { Policy } from "@app/interfaces/policy.interface";
import { BillingStoreService } from '@app/home/store/billing-store.service';
import { PayerInfoService } from '@app/home/payer-info/payer-info.service';
import { BillingStore } from '@app/interfaces/billing-store.interface';
import { environment } from '@env/environment';
import { ThemingService } from '@shared/services/theming.service';
import { Theme } from '@shared/themes/default.theme';
import { constants } from './../../../@shared/constants';
import { AptFeatureFlagService } from '@archinsurance-da/arch-portal-tools';
import { PendoService } from '@app/@shared/services/pendo/pendo.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SavedPaymentMethodService } from '@shared/services/saved-payment-method.service';
import { BillingInfoService, SavedCardProfile } from '@shared/services/billing-info.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  standalone: false,
})
export class PaymentComponent implements OnInit {
  // -- TEST VISA CARD: 4788250000028291
  TESTINGCHASE: boolean = false;
  cyberOfferEnabled: boolean = false;
  chaseUID: string = '';
  // chaseUID: string = 'E5248108A926994926D76734FE776B3A';

  BYPASSBINDCALL: boolean = true; //set to true for pay first bind after, false will require olicy to be bound before payment
  requestSent: boolean = false;
  iframeSrc: string = '';
  policyStore: BillingStore = {};
  addressString: string = '';
  errors: ChaseError[] = [];
  isCyberFlow: boolean = false;
  useSavedPaymentMethod: boolean = true;
  savedPaymentProfile: SavedCardProfile | null = null;
  loadingSavedPaymentProfile: boolean = false;

  processingPayment: boolean = false;
  coverageLiteralName: string;
  chase_version: number = 2;
  chaseSrc: string;
  paymentUsToken: string = '';
  safeSrc: SafeResourceUrl;
  iframeHeight: string = '100%';
  paymentUsSrc: string;
  show_paymentusFormOnly: boolean = false; //environment.envName.toLowerCase() == 'dev';
  paymentusFormOnly: boolean = false; //environment.envName.toLowerCase() == 'dev';
  //displayUID: string;
  displayToken: string;

  theme: Theme;

  contactNumber: string;
  contactInfo: string = `Arch Customer Support | customerservice@archinsurance.com | `; //A string of text to display under the timeout error

  constructor(
    private router: Router,
    private billingInfoService: BillingInfoService,
    private payerInfoService: PayerInfoService,
    private billingStoreService: BillingStoreService,
    private themeService: ThemingService,
    private pendoService: PendoService,
    private ffService: AptFeatureFlagService,
    private sanitizer: DomSanitizer,
    private savedPaymentMethodService: SavedPaymentMethodService
  ) {
    if (environment.chaseOrigin) {
      //chase sends alerts manually, override alerts from chase
      window.alert = function () {};
    }
  }
  d2cTheme: Theme;

  private loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  private setPaymentUsUrl() {
    this.paymentUsSrc = `${environment.paymentUsIframe}`;
    // console.log('this.payment', this.paymentUsSrc);
    // this.loadScript(
    //   `${environment.chaseOrigin[`version${this.chase_version}`].origin}${
    //     constants.chase[`version${this.chase_version}`].jsPath
    //   }`
    // );
  }

  private setChaseVersion(chase_version: number) {
    this.chase_version = chase_version;

    this.chaseSrc = `${environment.chaseOrigin[`version${this.chase_version}`].iframeOrigin}${
      constants.chase[`version${chase_version}`].iframePath
    }`;

    this.loadScript(
      `${environment.chaseOrigin[`version${this.chase_version}`].origin}${
        constants.chase[`version${this.chase_version}`].jsPath
      }`
    );
  }

  ngOnInit(): void {
    this.ffService.flagChange.subscribe((flags: any) => {
      const enterCustomUID = !flags.enterCustomUID?.current ? flags.enterCustomUID : flags.enterCustomUID.current;
      const cyberOfferEnabled = !flags.cyberOfferEnabled?.current
        ? flags.cyberOfferEnabled
        : flags.cyberOfferEnabled.current;

      this.TESTINGCHASE = enterCustomUID;
      this.cyberOfferEnabled = cyberOfferEnabled;
    });

    this.policyStore = this.billingStoreService.getBillingStore();

    if (!this.policyStore) {
      this.router.navigate(['policy']);
    }

    this.themeService.themeChange.subscribe((theme: Theme) => {
      this.theme = theme;
    });

    if (this.policyStore.product == 'ea') {
      this.setChaseVersion(2);
    } else {
      this.setChaseVersion(3);
    }
    this.setPaymentUsUrl();

    this.d2cTheme = JSON.parse(JSON.stringify(this.theme));
    if (this.d2cTheme.name != 'appalachian') {
      this.d2cTheme.agent.phone =
        this.policyStore.product == 'ea' ? constants.contactForCanopy : constants.contactForNationwideD2C;
    }
    this.addressString = `${this.policyStore.policyData.policy.addressDto.insuredAddressStreetLine1Txt}, ${this.policyStore.policyData.policy.addressDto.insuredAddressCityTxt}, ${this.policyStore.policyData.policy.addressDto.insuredAddressStateCd} ${this.policyStore.policyData.policy.addressDto.insuredAddressPostalCd}`;

    this.isCyberFlow = this.getIsCyberFlowFromPolicy();
    this.billingStoreService.setCyberFlag(this.isCyberFlow ? 'Y' : 'N');
    this.loadSavedPaymentProfile();

    // // For cyber flow, check if payment was already made (uidToken exists in sessionStorage)
    // if (isCyberFlow) {
    //   const uidTokenData = sessionStorage.getItem('uidToken');
    //   if (uidTokenData) {
    //     console.log('Cyber Flow - uidToken found in sessionStorage, payment already made');
    //     // Payment already processed for cyber flow, redirect to success
    //     //this.router.navigate(['direct/success']);
    //     return;
    //   }
    // }

    if (!this.isCyberFlow && this.policyStore?.policyData?.policy?.quoteCoverageList) {
      this.coverageLiteralName =
        this.policyStore?.policyData?.policy?.quoteCoverageList[0].coverageCodeInfo.coverageLiteralName.replace(
          'Miscellaneous/Specified',
          'Miscellaneous'
        );
    }

    if (this.policyStore?.policyData?.referenceData?.product?.productOffering) {
      const productMapping: any = {
        PRDCNP: 'Management Liability', //'Arch Corporate Canopy Policy Private Company Management Liability & Crime Insurance',
        MSPPL: 'Miscellaneous/Specified Professional Liability',
        MSSPL: 'Miscellaneous/Specified Professional Liability',
      };
      let productOffering = this.policyStore.policyData.referenceData.product.productOffering;
      // console.log('productOffering', productOffering);
      this.coverageLiteralName = productMapping[productOffering] ? productMapping[productOffering] : productOffering;
    }

    // if (this.chaseUID) {
    //   //hosted_tokenize=store_authorize
    //   this.updateChaseIframe(this.chaseUID);
    // } else {
    //   this.payerInfoService
    //     .getPaymentTechUID(
    //       this.policyStore,
    //       'https://aigidigassets.blob.core.windows.net/payment-portal-assets/arch-chase-billing-portal-fluid.css',
    //       true
    //     )
    //     .subscribe((data: any) => {
    //       // console.log('getPaymentTechUID data', data);
    //       //call iframe service
    //       this.updateChaseIframe(data.uID);
    //       // this.iframeSrc = `${this.chaseSrc}${data.uID}`;
    //     });
    // }

    if (this.paymentUsToken) {
      this.updatePaymentUsIframe(this.paymentUsToken);
    } else {
      this.payerInfoService.getPaymentUsToken(this.policyStore, true).subscribe((data: any) => {
        // console.log('dataPaymentUs', data);
        this.updatePaymentUsIframe(data.token);
      });
    }
  }

  updatePaymentUsIframe(paymentUsToken: string) {
    this.displayToken = paymentUsToken;
    this.iframeSrc = `${this.paymentUsSrc}${this.displayToken}`;
    console.log('this.iframeScr', this.iframeSrc);
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeSrc);
  }
  // updateChaseIframe(chaseUid: string) {
  //   // console.log('chaseUid', chaseUid);
  //   // this.displayUID = chaseUid;
  //   //  this.iframeSrc = `${this.chaseSrc}${chaseUid}`;
  //   //  console.log('this.iframeSrc', this.iframeSrc);
  // }

  goToPolicy() {
    this.router.navigate(['policy', btoa(this.policyStore.id)]);
  }

  processPayMessages: string[] = [
    'Thank you for your request.',
    'Validating your payment.',
    'Issuing the policy.',
    'Updating and synchronizing our records.',
    'Saving updated information to your policy.',
    'Polishing up final details.',
    'Your time is very important to us.',
    'We should be finishing up shortly. Thank you for your patience.',
  ];
  savedPaymentLookupMessages: string[] = ['Checking for your saved payment method.'];
  processPayTimedOut: boolean = false;
  processPayTimeOutChange($event: any) {
    console.log('payment timed out $event', $event);
  }

  private getIsCyberFlowFromPolicy(): boolean {
    const policyOffering =
      this.policyStore?.policyData?.responseJSON?.policy?.productOffering ||
      this.policyStore?.policyData?.referenceData?.product?.productOffering;

    if (policyOffering) {
      return policyOffering === 'NPL';
    }

    return this.billingStoreService.isCyberFlow();
  }

  get showSavedPaymentOption(): boolean {
    return this.isCyberFlow && !!this.savedPaymentProfile?.token;
  }

  get showPaymentIframe(): boolean {
    return !!this.iframeSrc && (!this.showSavedPaymentOption || !this.useSavedPaymentMethod);
  }

  get savedPaymentLabel(): string {
    return `Use existing payment method (${this.getMaskedSavedCardNumber()})`;
  }

  payWithSavedPaymentMethod(): void {
    if (!this.showSavedPaymentOption) {
      return;
    }

    const savedPaymentMethod = this.savedPaymentMethodService.getSavedPaymentMethod();
    const mplGuid = savedPaymentMethod?.mplGuid;
    const cyberGuid = this.policyStore?.id;

    if (!mplGuid || !cyberGuid) {
      this.errors.push({
        code: 'NA',
        message: 'Unable to use saved payment method. Please enter a new card.',
      });
      return;
    }

    this.processingPayment = true;
    this.billingInfoService
      .processSavedCard(
        {
          mplGuid,
          cyberGuid,
          amount: this.getPaymentAmount(),
        },
        true
      )
      .subscribe(
        (response: any) => {
          this.handleAuthorizedPaymentResponse(response, this.savedPaymentProfile?.token);
        },
        (errorResponse: any) => {
          console.log('errorResponse', errorResponse);
          this.processingPayment = false;
          this.errors.push({
            code: 'NA',
            message: 'There was an unexpected error. Please contact Arch Service Center for support.',
          });
        }
      );
  }

  private loadSavedPaymentProfile(): void {
    if (!this.isCyberFlow) {
      return;
    }

    const savedPaymentMethod = this.savedPaymentMethodService.getSavedPaymentMethod();
    const mplGuid = savedPaymentMethod?.mplGuid;
    if (!mplGuid) {
      return;
    }

    this.loadingSavedPaymentProfile = true;
    this.billingInfoService.getSavedPaymentProfile(mplGuid, true).subscribe(
      (profile) => {
        if (profile?.token) {
          this.savedPaymentProfile = profile;
          this.useSavedPaymentMethod = true;
        }
        this.loadingSavedPaymentProfile = false;
      },
      () => {
        this.loadingSavedPaymentProfile = false;
      }
    );
  }

  private getMaskedSavedCardNumber(): string {
    const last4 = this.savedPaymentProfile?.cardNo;
    if (!last4) {
      return '****';
    }

    return `**** **** **** ${last4}`;
  }

  private getPaymentAmount(): number {
    const amount = Number(this.policyStore?.dueToday ?? this.policyStore?.total ?? 0);
    return Number(amount.toFixed(2));
  }

  private handleAuthorizedPaymentResponse(response: any, token: string): void {
    if (this.theme?.agent?.phoneD2C) {
      this.policyStore.policyData.responseJSON.policy.supportPhoneNo = this.theme.agent.phoneD2C;
    }

    const uid = response?.['payment-response']?.['reference-number'];
    if (response?.['payment-response']?.['payment-status'] === 'ACCEPTED' && uid && token) {
      const existingSavedPayment = this.savedPaymentMethodService.getSavedPaymentMethod();
      if (existingSavedPayment?.paymentusResponse) {
        this.savedPaymentMethodService.setSavedPaymentMethod({
          mplGuid: this.policyStore?.id,
          paymentusResponse: existingSavedPayment.paymentusResponse,
        });
      }

      this.completePostPaymentProcessing(uid, token);
      return;
    }

    this.processingPayment = false;
    this.errors.push({
      code: 'NA',
      message:
        response?.['payment-response']?.['payment-status-description'] ||
        'There was an unexpected error. Please contact Arch Service Center for support.',
    });
  }

  private completePostPaymentProcessing(uid: string, token: string): void {
    this.payerInfoService.doPostPaymentProcessing(uid, token, this.policyStore, true).subscribe(
      (response: any) => {
        this.processingPayment = false;
        if (response === true || response?.returnCode === 'SUCCESS') {
          sessionStorage.setItem('successPayData', JSON.stringify(response));

          if (this.policyStore.policyData.policy.renewalFlag && this.policyStore.policyData.policy.renewalFlag == 'Y') {
            this.router.navigate(['direct/success']);
          } else {
            if (this.policyStore.redirectUrl && this.payerInfoService.validateUrl(atob(this.policyStore.redirectUrl))) {
              if (this.isCyberFlow) {
                location.href = this.payerInfoService.getRedirectUrlWithParams(this.policyStore);
              } else if (!this.cyberOfferEnabled) {
                location.href = this.payerInfoService.getRedirectUrlWithParams(this.policyStore);
              } else {
                this.router.navigate(['direct/success']);
              }
            } else {
              this.router.navigate(['direct/success']);
            }
          }
        }
      },
      (errorResponse: any) => {
        console.log('errorResponse', errorResponse);
        this.errors.push({
          code: 'NA',
          message: 'There was an unexpected error. Please contact Arch Service Center for support.',
        });
      }
    );
  }

  //Handle events coming from the payment iframe
  @HostListener('window:message', ['$event'])
  handlePostMessages($event: MessageEvent) {
    if ($event.origin === environment.paymentUsOrigin) {
      this.errors = [];
      let data = $event.data;
      let sender = $event.data.split(':');
      if (sender[0] == 'pmDetails') {
        this.processingPayment = true;
        data = JSON.parse(data.slice(10));
        const token = data.Token;
        let authData;
        this.payerInfoService.authProcessingPaymentUs(token, this.policyStore, true).subscribe(
          (response: any) => {
            authData = response;
            // console.log('response', response);
            if (response['payment-response']['payment-status'] == 'ACCEPTED') {
              // sessionStorage.setItem('uidToken', JSON.stringify({ uid, token })); //set uid and token into sessionStorage, also need to store the card number  (XXXXXXXXXX1234) and the card type.
              this.savedPaymentMethodService.setSavedPaymentMethod({
                mplGuid: this.policyStore?.id,
                paymentusResponse: data,
              });
              this.handleAuthorizedPaymentResponse(response, token);
            } else {
              console.log('errorResponse', response);
              this.processingPayment = false;
              if (response['payment-response']['payment-status-description'] == null) {
                this.errors.push({
                  code: 'NA',
                  message: 'There was an unexpected error. Please contact Arch Service Center for support.',
                });
              } else {
                this.errors.push({
                  code: 'NA',
                  message: response['payment-response']['payment-status-description'],
                });
              }
            }
          },
          (errorResponse: any) => {
            console.log('errorResponse', errorResponse);
            this.processingPayment = false;
            this.errors.push({
              code: 'NA',
              message: 'There was an unexpected error. Please contact Arch Service Center for support.',
            });
          }
        );
      } else if (sender[0] == 'Result') {
        console.log('Error:', $event.data);
        this.processingPayment = false;
        this.errors.push({
          code: 'NA',
          message: 'There was an unexpected error. Please contact Arch Service Center for support.',
        });
      }
    }
  }
}
